import { render, staticRenderFns } from "./AppCalendarIcon.vue?vue&type=template&id=c15bbd16&scoped=true&"
import script from "./AppCalendarIcon.vue?vue&type=script&lang=js&"
export * from "./AppCalendarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15bbd16",
  null
  
)

export default component.exports